import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { ProfileForm } from './profile-form';
import { TextboxModule } from '../inputs/textbox/textbox.module';
import { ProfileFormDialog } from './profile-form-dialog.component';

@NgModule({
    declarations: [ProfileForm, ProfileFormDialog],
    exports: [ProfileForm, ProfileFormDialog],
    imports: [CommonModule, FormsModule, TextboxModule, MatDialogModule],
})
export class ProfileFormModule {
}
